import { render, staticRenderFns } from "./CarouselLayout.vue?vue&type=template&id=c7d76534&scoped=true&"
import script from "./CarouselLayout.vue?vue&type=script&lang=js&"
export * from "./CarouselLayout.vue?vue&type=script&lang=js&"
import style0 from "./CarouselLayout.vue?vue&type=style&index=0&id=c7d76534&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7d76534",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCarousel,VCarouselItem,VCol,VImg,VRow})
